import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.css']
})
export class RootComponent implements OnInit {

  userLogado;

  constructor() { }

  ngOnInit() {
    this.userLogado = JSON.parse(localStorage.getItem("user_logado"));
  }

  ngAfterViewInit(){
  }

}
